import React, { useEffect, useState } from "react";

// Chakra imports
import {
  Grid,
  Flex,
  Box,
  IconButton,
  Icon,
  Tabs,
  Tab,
  TabList,
  TabIndicator,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  ModalHeader,
  Text,
  useColorModeValue,
  Divider,
} from "@chakra-ui/react";

import {
  MdOutlineRemoveCircleOutline,
  MdOutlineAttachMoney,
  MdDateRange,
  MdSearch,
  MdClose,
} from "react-icons/md";
import {
  IsEmpty,
  maskDataContaVirtual,
  formatarParaMoeda,
  maskDataHistoricoSemHoraAvulso,
} from "config/functions";
import { pt } from "date-fns/locale";
import { IoSearch, IoCloseCircle } from "react-icons/io5";
import { DateRangePicker } from "react-date-range";
import { pesquisaCartaoAvulso } from "config/apis/requests";

//COMPONENTS
import PopOverAlertOrange from "components/popAlert/popAlert";
import Transaction from "components/dataDisplay/TransactionCartaoAvulso";
import PopOverAlert from "components/popAlert/popAlert";
import InputField from "components/fields/InputField";

export default function ConsultaAvulso() {
  const redIcon = useColorModeValue("red.500", "white");
  const [numeroCartao, setNumeroCartao] = useState("");
  const [loading, setLoading] = useState(false);
  const [isOpenAlerta, setIsOpenAlerta] = useState(false);
  const [msgAlert, setMsgAlert] = useState("");
  const [extratoCartaoAvulso, setExtratoCartaoAvulso] = useState([]);
  const [somaPesquisaUtilizacao, setSomaPesquisaUtilizacao] = useState(0.0);
  const [valorSaldo, setValorSaldo] = useState(0.0);

  const [modalData, setModalData] = useState(false);
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const shadow = useColorModeValue(
    "18px 17px 40px 4px rgba(112, 144, 176, 0.1)",
    "unset"
  );
  const handleOpenAlert = (status: boolean) => {
    setIsOpenAlerta(status);
  };
  const handleKeyDown = (e: { key: string }) => {
    if (e.key === "Enter") {
      onClickPesquisar();
    }
  };
  const handleSelect = (ranges: any) => {
    setSelectedDateRange(ranges.selection);
  };
  const showPopOver = () => {
    handleOpenAlert(true);
  };
  const onClickLimparFiltros = async () => {
    //setDataCartao([]);
    setNumeroCartao("");
    setSomaPesquisaUtilizacao(0.0);
    setExtratoCartaoAvulso([]);
    selectedDateRange.endDate = new Date();
    selectedDateRange.startDate = new Date();
  };
  const logout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    localStorage.removeItem("stayLogged");

    setTimeout(function () {
      window.location.href = "/atendimento#/auth/sign-in";
      window.location.reload();
    }, 3000);
  };

  const onPesquisar = async () => {
    setSomaPesquisaUtilizacao(0.0);
    onChangeModalDataClose();
    setExtratoCartaoAvulso([]);
    if (numeroCartao) {
      const dataCartaoData = await pesquisaCartaoAvulso({
        idProduto: 4,
        dateRangeApi: selectedDateRange,
        numeroCartao: numeroCartao,
      });
      setValorSaldo(dataCartaoData?.valorSaldo || "0.00");
      let valorNegativo = 0;
      let valorPositivo = 0;
      if (
        dataCartaoData?.utilizacoes &&
        dataCartaoData?.utilizacoes.length > 0
      ) {
        dataCartaoData?.utilizacoes.forEach((extrato: any) => {
          if (extrato.tipoUtilizacao === 2) {
            valorPositivo += extrato.valorTransacao;
          }
          if (extrato.tipoUtilizacao === 1) {
            valorNegativo += extrato.valorTransacao;
          }
        });
        const total = valorPositivo + Math.trunc(valorNegativo * 100) / 100;
        setSomaPesquisaUtilizacao(total);
        setExtratoCartaoAvulso(dataCartaoData?.utilizacoes);
      } else if (dataCartaoData?.request?.status === 403) {
        setMsgAlert("Sessão expirada!");
        showPopOver();
        setLoading(false);
        logout();
      } else {
        setMsgAlert("Sem dados disponíveis!");
        showPopOver();
        setLoading(false);
      }
      setModalData(!modalData);
    } else {
      setMsgAlert("Digite o número do cartão!");
      showPopOver();
      setLoading(false);
    }
  };
  const onChangeModalDataClose = () => {
    if (document.getElementById("fotoElementoUsuario"))
      if (document.getElementById("fotoElementoUsuario"))
        document.getElementById("fotoElementoUsuario").style.display = "block";
    if (document.getElementById("fotoElementoUsuario2"))
      if (document.getElementById("fotoElementoUsuario2"))
        document.getElementById("fotoElementoUsuario2").style.display = "block";
    setModalData(!modalData);
  };
  const [selectedDateRange, setSelectedDateRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });
  const onChangeModalData = () => {
    if (document.getElementById("fotoElementoUsuario"))
      if (document.getElementById("fotoElementoUsuario"))
        document.getElementById("fotoElementoUsuario").style.display = "none";
    if (document.getElementById("fotoElementoUsuario2"))
      if (document.getElementById("fotoElementoUsuario2"))
        document.getElementById("fotoElementoUsuario2").style.display = "none";
    setModalData(!modalData);
  };

  const dateRangeApi: any = {
    startDate: null,
    endDate: null,
    key: "selection",
  };

  const onClickPesquisar = async () => {
    setLoading(true);

    if (selectedDateRange.startDate === selectedDateRange.endDate) {
      dateRangeApi.startDate = maskDataContaVirtual(
        selectedDateRange.startDate
      );
      dateRangeApi.endDate = maskDataContaVirtual(selectedDateRange.endDate);
    } else {
      const startDate = new Date();
      startDate.setMonth(startDate.getMonth() - 1);
      const endtDate = new Date();
      endtDate.setDate(endtDate.getDate() + 1);

      dateRangeApi.startDate = maskDataContaVirtual(startDate);
      dateRangeApi.endDate = maskDataContaVirtual(endtDate);
    }

    if (numeroCartao) {
      const dataCartao = await pesquisaCartaoAvulso({
        idProduto: 4,
        dateRangeApi,
        numeroCartao: numeroCartao,
      });
      let valorPositivo = 0;
      let valorNegativo = 0;

      setValorSaldo(dataCartao?.valorSaldo || "0.00");
      if (dataCartao?.utilizacoes.length > 0) {
        dataCartao?.utilizacoes.forEach((extrato: any) => {
          if (extrato.tipoUtilizacao === 2) {
            valorPositivo += extrato.valorTransacao;
          }
          if (extrato.tipoUtilizacao === 1) {
            valorNegativo += extrato.valorTransacao;
          }
        });

        const total = valorPositivo + Math.trunc(valorNegativo * 100) / 100;
        setSomaPesquisaUtilizacao(total);
        setExtratoCartaoAvulso(dataCartao?.utilizacoes);
      } else {
        setMsgAlert("Nenhum dado encontrato!");
        setLoading(false);
      }
      setLoading(false);
    } else {
      handleOpenAlert(true);
      setMsgAlert("O campo de busca deve ser preenchido!");
      setLoading(false);
    }
  };

  const pesquisaUtilizacao = async () => {
    setExtratoCartaoAvulso([]);
    setSomaPesquisaUtilizacao(0.0);
    const historicoApiUti = await pesquisaCartaoAvulso({
      idProduto: 4,
      dateRangeApi: selectedDateRange,
      numeroCartao,
    });
    setValorSaldo(historicoApiUti?.valorSaldo || "0.00");
    let valorNegativo = 0;
    const historicoExtratoNegativo: any[] = [];
    historicoApiUti?.utilizacoes.forEach((extrato: any) => {
      if (extrato.tipoUtilizacao === 1) {
        historicoExtratoNegativo.push(extrato);
        valorNegativo += extrato.valorTransacao;
      }
    });

    setSomaPesquisaUtilizacao(Math.trunc(valorNegativo * 100) / 100);
    setExtratoCartaoAvulso(historicoExtratoNegativo);
  };

  const pesquisaCredito = async () => {
    setExtratoCartaoAvulso([]);
    setSomaPesquisaUtilizacao(0.0);
    const historicoApiCredito = await pesquisaCartaoAvulso({
      idProduto: 4,
      dateRangeApi: selectedDateRange,
      numeroCartao,
    });
    setValorSaldo(historicoApiCredito?.valorSaldo || "0.00");
    let valorPositivo = 0;
    const historicoExtratoCredito: any[] = [];
    historicoApiCredito?.utilizacoes.forEach((extrato: any) => {
      if (extrato.tipoUtilizacao === 2) {
        historicoExtratoCredito.push(extrato);
        valorPositivo += extrato.valorTransacao;
      }
    });

    setSomaPesquisaUtilizacao(valorPositivo);
    setExtratoCartaoAvulso(historicoExtratoCredito);
  };

  const onPesquisarTodos = async (dateRange: any) => {
    setExtratoCartaoAvulso([]);
    setSomaPesquisaUtilizacao(0.0);
    let valorPositivo = 0;
    let valorNegativo = 0;
    const historicoApiTodos = await pesquisaCartaoAvulso({
      idProduto: 4,
      dateRangeApi: dateRange,
      numeroCartao,
    });
    setValorSaldo(historicoApiTodos?.valorSaldo || "0.00");
    historicoApiTodos?.utilizacoes.forEach((extrato: any) => {
      if (extrato.tipoUtilizacao === 2) {
        valorPositivo += extrato.valorTransacao;
      }
      if (extrato.tipoUtilizacao === 1) {
        valorNegativo += extrato.valorTransacao;
      }
    });

    const total = valorPositivo + Math.trunc(valorNegativo * 100) / 100;
    setSomaPesquisaUtilizacao(total);
    setExtratoCartaoAvulso(historicoApiTodos?.utilizacoes);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  });
  return (
    <Box pt={{ base: "140px", md: "80px", xl: "80px" }}>
      {/* Main Fields */}
      <PopOverAlertOrange
        handleOpenAlert={handleOpenAlert}
        isOpen={isOpenAlerta}
        title="Ops..."
        subtitle={msgAlert}
      />
      <PopOverAlert
        status={"error"}
        handleOpenAlert={handleOpenAlert}
        isOpen={isOpenAlerta}
        title="Ops..."
        subtitle={msgAlert}
      />
      <Grid
        mb="20px"
        gridTemplateColumns={{ xl: "repeat(1, 1fr)", "1xl": "1fr 0.46fr" }}
        gap={{ base: "20px", xl: "20px" }}
        display={{ base: "block", xl: "grid" }}
      >
        <Flex flexDirection="column" mt={"15px"} w="100%">
          <Flex
            direction={{ base: "column", md: "row" }}
            alignContent={"center"}
            justifyContent={"center"}
            alignItems={{ base: "center", md: "flex-end" }}
            gap={{ base: "15px", md: "0px" }}
          >
            <InputField
              isRequired={true}
              ml={{ base: "0px", md: "25px" }}
              w={{ base: "100%", md: "350px" }}
              h="50px"
              id="nome"
              label="Nº cartão avulso"
              value={numeroCartao}
              onKeyDown={handleKeyDown}
              onChange={(e: {
                target: { value: React.SetStateAction<string> };
              }) => setNumeroCartao(e.target.value)}
            />
            
            <Flex direction="row" ml={{ base: "0px", md: "25px" }} mt={{ base: "5px", md: "0px" }}>
              <IconButton
                mt={{ base: "0px", md: "30px" }}
                aria-label="share"
                w="40px"
                h="40px"
                variant="brand"
                borderRadius="20%"
                onClick={onChangeModalData}
                isLoading={loading}
              >
                <Icon w="14px" h="14px" as={IoSearch} color="white" />
              </IconButton>

              <IconButton
                mt={{ base: "0px", md: "30px" }}
                ml={"15px"}
                aria-label="share"
                w="40px"
                h="40px"
                variant="brand"
                borderRadius="20%"
                onClick={onClickLimparFiltros}
              >
                <Icon w="14px" h="14px" as={IoCloseCircle} color="white" />
              </IconButton>
            </Flex>
            <PopOverAlert
              status={"error"}
              handleOpenAlert={handleOpenAlert}
              isOpen={isOpenAlerta}
              title="Ops..."
              subtitle={msgAlert}
            />
          </Flex>

          <>
            <Flex
              justify="space-between"
              direction="row"
              align={"center"}
              me={{ base: "0px", md: "40px", "2xl": "36px" }}
              w={"100%"}
              mt="20px"
            >
              <Text fontSize="md" color={textColor} fontWeight="700">
                Extrato{" "}
                {selectedDateRange.startDate === null ? (
                  <Text fontSize="sm" color={textColor} fontWeight="300">
                    Último dia
                  </Text>
                ) : (
                  <Text fontSize="md" color={textColor} fontWeight="300">
                    {maskDataHistoricoSemHoraAvulso(
                      selectedDateRange.startDate
                    )}{" "}
                    à{" "}
                    {maskDataHistoricoSemHoraAvulso(selectedDateRange.endDate)}
                  </Text>
                )}
              </Text>
              <IconButton
                aria-label="Top"
                borderRadius="50%"
                mb="5px"
                boxShadow={shadow}
                icon={
                  <Icon
                    as={MdDateRange}
                    w="24px"
                    h="24px"
                    onClick={onChangeModalData}
                  />
                }
              />
            </Flex>
            {!IsEmpty(extratoCartaoAvulso) && (
              <Flex
                justify="flex-start"
                direction="row"
                mt="15px"
                align={"center"}
                w={"100%"}
              >
                <Text fontSize="md" color={textColor} fontWeight="700">
                  Saldo atual{" "}
                  <Text
                    fontSize="dm"
                    color={
                      valorSaldo === 0 || valorSaldo < 0
                        ? "red.400"
                        : "green.400"
                    }
                    fontWeight="500"
                  >
                    R$ {valorSaldo === 0 ? "0,00" : valorSaldo}
                  </Text>
                </Text>
              </Flex>
            )}
            <Flex justify={{ base: "center", md: "end" }} direction="row" align={"center"} w={"100%"} wrap="wrap">
              <Text
                fontSize="md"
                color={textColor}
                fontWeight="700"
                mr={"15px"}
                mb={"15px"}
              >
                Filtros:
              </Text>
              <Tabs isManual variant="enclosed" mb={"15px"} w={{ base: "100%", md: "auto" }}>
                <TabList justifyContent={{ base: "center", md: "flex-start" }}>
                  <Tab onClick={() => onPesquisarTodos(selectedDateRange)}>
                    {" "}
                    <Text fontSize="sm" color={"blue.400"} fontWeight="300">
                      Todos
                    </Text>
                  </Tab>
                  <Tab
                    onClick={() => pesquisaCredito()}
                    _selected={{ color: "white", bg: "blue.400" }}
                  >
                    {" "}
                    <Text fontSize="sm" fontWeight="300">
                      <Icon as={MdOutlineAttachMoney} /> Crédito
                    </Text>
                  </Tab>
                  <Tab
                    onClick={() => pesquisaUtilizacao()}
                    _selected={{ color: "white", bg: "red.400" }}
                  >
                    {" "}
                    <Text fontSize="sm" fontWeight="300">
                      <Icon as={MdOutlineRemoveCircleOutline} /> Utilização
                    </Text>
                  </Tab>
                </TabList>
                <TabIndicator
                  mt="-1.5px"
                  height="2px"
                  bg="blue.500"
                  borderRadius="0px"
                  border={"0px"}
                />
              </Tabs>
            </Flex>
            {somaPesquisaUtilizacao !== 0 && (
              <Flex
                justify={{ base: "center", md: "flex-end" }}
                direction="row"
                ml={{ base: "0px", md: "-15px" }}
                align={"center"}
                me={{ base: "0px", md: "82px", "2xl": "36px" }}
                w={"100%"}
                mb="10px"
              >
                <Text fontSize="sm" color={textColor} fontWeight="700">
                  Total período:{" "}
                </Text>

                <Text
                  fontSize="md"
                  color={somaPesquisaUtilizacao < 0 ? "red.400" : "green.400"}
                  fontWeight="700"
                  style={{ marginLeft: "5px" }}
                >
                  {formatarParaMoeda(somaPesquisaUtilizacao)}
                </Text>
              </Flex>
            )}
          </>

          <>
            {/* <Text fontSize="lg" color={redIcon} fontWeight="700" mt={"10px"}>
              Para verificar o saldo do cartão avulso, solicite ao cliente que
              utilize um ATM Jaé.
            </Text> */}
            <Text fontSize="lg" color={redIcon} fontWeight="700" mt={"10px"}>
              Observação: Pode haver divergências nas informações exibidas aqui
              em caso de transações não processadas ou com erro.
            </Text>
            <Divider mt="10px" />
            <Box
              overflowX="hidden"
              //overflowY={usuariosPesquisa.length > 7 ? "scroll" : "hidden"}
              w="100%"
              maxW="100%"
              h={"490px"}
              whiteSpace="nowrap"
              pb="17px"
            >
              {!IsEmpty(extratoCartaoAvulso) ? (
                extratoCartaoAvulso.map((extrato, i) => (
                  <Flex
                    key={i}
                    w="100%"
                    alignSelf={"center"}
                    justifyItems={"center"}
                    me={{ base: "0px", md: "82px", "2xl": "36px" }}
                    backgroundColor={
                      i % 2 === 0 ? "blackAlpha.50" : "blackAlpha.55"
                    }
                  >
                    <Transaction extrato={extrato} />
                  </Flex>
                ))
              ) : (
                <Text
                  fontSize="md"
                  color={redIcon}
                  fontWeight="500"
                  align={"center"}
                  mt={"9px"}
                >
                  Sem dados disponíveis para pesquisa.
                </Text>
              )}
            </Box>

            <Divider />
          </>
        </Flex>
      </Grid>
      <Modal isOpen={modalData} onClose={onChangeModalDataClose} size={{ base: "full", md: "md" }}>
        <ModalOverlay />
        <ModalContent alignSelf={"center"}>
          <ModalHeader>Escolha o período</ModalHeader>
          <ModalCloseButton />
          <ModalBody p={0}>
            <Flex justify="center" align="center" direction="column" w="100%" overflowX="auto">
              <DateRangePicker
                className="rdrDefinedRangesWrapper "
                onChange={handleSelect}
                moveRangeOnFirstSelection={false}
                months={1}
                showMonthAndYearPickers={true}
                ranges={[selectedDateRange]}
                direction="vertical"
                locale={pt}
                displayMode="date"
                dragSelectionEnabled={true}
                showDateDisplay={true}
                headerContent={true}
                scroll={{ enabled: false }}
                showPreview={false}
                dateDisplayFormat="dd MMM, yyyy"
                editableDateInputs={false}
                staticRanges={[]}
                inputRanges={[]}
              />
            </Flex>
          </ModalBody>
          <ModalFooter>
            <Button
              leftIcon={<MdClose />}
              colorScheme="red"
              mr={3}
              onClick={() => onChangeModalDataClose()}
            >
              Fechar
            </Button>
            <Button
              leftIcon={<MdSearch />}
              colorScheme="brand"
              mr={3}
              onClick={() => onPesquisar()}
            >
              Pesquisar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
}
